// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3hJ9Q","detailsBorder":"styles_detailsBorder__1PiP4"};